import _typeof from "@babel/runtime/helpers/typeof";
var printParam = function printParam(param) {
  if (typeof param === 'string') {
    return "'".concat(param, "'");
  } else if (_typeof(param) === 'object') {
    return JSON.stringify(param);
  } else if (param === undefined) {
    return 'undefined';
  }
  return param;
};
var printParams = function printParams(args) {
  return args.map(function (arg) {
    return printParam(arg);
  }).join(',');
};
export var printFunctionCall = function printFunctionCall(fn) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  return "(".concat(fn.toString(), ")(").concat(printParams(args), ");");
};

// Removing the script tag after execution to prevent hydration
// mismatch issues after SSR. We don't want to render different
// HTML on the client and server https://react.dev/reference/react-dom/client/hydrateRoot
// Note: document.currentScript gets incorrectly transpiled to globalThis.currentScript so we need to use it here to avoid transpilation
export var printScript = function printScript(statements) {
  return "(function(){\n\t\t\t let script = document.currentScript;\n \t\t\t ".concat(statements.join(';'), "\n\t\t\t document.currentScript.remove();\n\t\t})();\n\t\t");
};